<template>
    <div>
        <navigation/>

        <h1>The Top 20 Pimblr Blogs</h1>

        <top20 target="_self"/>

    </div>
</template>

<script>
    import Navigation from '../layout/MainNavigation.vue';
    import Top20 from "./Top20";

    export default {
        name: 'BlogsCharts',
        metaInfo: {
            title: 'Top 20 Blogs'
        },
        data() {
            return {}
        },
        mounted() {

        },
        methods: {

        },
        components: {
            Top20,
            Navigation,
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/blogs/BlogsCharts.vue